import { Attribute } from 'src/app/shared/models/attributes/attribute';

export class MemberEvaluatee {
  seatId: string;
  evaluationAssignmentId: string;
  fullName: string;
  positionTitle: string;
  attributes: Attribute[] = [];

  public static parse(data: IMemberEvaluatee): MemberEvaluatee {
    let evaluate = new MemberEvaluatee();
    evaluate.seatId = data.seatId;
    evaluate.evaluationAssignmentId = data.evaluationAssignmentId;
    evaluate.fullName = data.fullName;
    evaluate.positionTitle = data.positionTitle;
    evaluate.attributes = data.customFields
      .concat(data.trackedFields)
      .map((a) => Attribute.parse(a));
    return evaluate;
  }
}

export interface IMemberEvaluatee {
  seatId: string;
  evaluationAssignmentId: string;
  fullName: string;
  positionTitle: string;
  customFields: Attribute[];
  trackedFields: Attribute[];
}
